<template>
  <div class="flex flex-col">
    <div
      v-if="filteredSection.name"
      class="p-4 gap-4 flex items-center justify-between"
    >
      <!-- <div>
        <BaseCircularProgress :value="progress" />
      </div> -->

      <div class="w-full gap-1 flex flex-col">
        <span class="text-sm font-semibold text-[#7C7C7C]">{{
          section.name
        }}</span>

        <div class="gap-1 flex items-center text-xs text-[#B3B3B3] font-normal">
          <div class="gap-1 flex">
            <BaseIcon class="text-xs" icon="poll-h" />
            <span>{{ totalTopicsNormalized }}</span>
          </div>
          <span>|</span>
          <span>{{ beautifyNumber }} {{ $t('hub.sections.exercises') }}</span>
        </div>
      </div>
    </div>

    <TopicsList :list="filteredSection.topics" :section-slug="section.slug" />
  </div>
</template>

<script>
import { mapState } from 'vuex'

import BaseIcon from '@/components/Base/BaseIcon.vue'
// import BaseCircularProgress from '@/components/Base/BaseCircularProgress.vue'

import TopicsList from '@/components/Hub/Topics/TopicsList.vue'

const pluralize = number => {
  const cases = [2, 0, 1, 1, 1, 2]
  const pluralForms = [
    'hub.sections.topics.one',
    'hub.sections.topics.few',
    'hub.sections.topics.many'
  ]
  const formIndex =
    number % 100 > 4 && number % 100 < 20
      ? 2
      : cases[number % 10 < 5 ? number % 10 : 5]
  return pluralForms[formIndex]
}

export default {
  name: 'HubSectionsListItem',

  components: { BaseIcon, TopicsList },

  props: {
    filteredSection: { type: Object, required: true }
  },

  computed: {
    // ...mapState('user', ['user']),
    ...mapState('sections', ['sections']),

    sectionSlug() {
      return this.filteredSection.slug
    },

    section() {
      return this.sections.list.find(
        section => section.slug === this.sectionSlug
      )
    },

    totalExercises() {
      return this.section.topics.reduce((sum, topic) => {
        sum += topic.totalExercises
        return sum
      }, 0)
    },

    totalTopics() {
      return this.section.topics.length
    },

    totalTopicsNormalized() {
      return `${this.totalTopics} ${this.$t(pluralize(this.totalTopics))}`
      // return `${this.totalTopics} topics`
    },

    beautifyNumber() {
      if (this.totalExercises < 1000) {
        return Math.round(this.totalExercises / 100) * 100 + '+'
      } else {
        return (
          Math.round(this.totalExercises / 1000) + ',000+'
          // this.$t('hub.sections.thousand')
        )
        // return Math.round(this.totalExercises / 1000) + 'k'
      }
    }

    // progress() {
    //   if (!this.user) return 0

    //   const sectionRecord = this.user.sectionRecords?.[this.section.slug] || {}
    //   const sectionRecordTotalInStars = Object.values(
    //     this.user.sectionRecords
    //   ).reduce((total, topicRecord) => total + topicRecord.stars, 0)

    //   if (!sectionRecord) return 0

    //   return Math.round(
    //     (sectionRecordTotalInStars * 100) / (this.totalTopics * 3)
    //   )
    // }
  }
}
</script>
